import React from "react"

const Col = ({ children, xs, sm, md, lg, xl, xxl, className, offset}) => {
  let nxs = `${xs!=="object" && xs && xs.constructor !== Object ? `col-${xs}`: `${xs?.span ? `col-${xs.span}` : ''}`}`
  let nsm = `${sm!=="object" && sm && sm.constructor !== Object  ? `col-sm-${sm}`: `${sm?.span ? `col-sm-${sm.span}` : ''}`}`
  let nmd = `${md!=="object" && md && md.constructor !== Object  ? `col-md-${md}`: `${md?.span ? `col-md-${md.span}` : ''}`}`
  let nlg = `${lg!=="object" && lg && lg.constructor !== Object  ? `col-lg-${lg}`: `${lg?.span ? `col-lg-${lg.span}` : ''}`}`
  let nxl = `${xl!=="object" && xl && xl.constructor !== Object  ? `col-xl-${xl}`: `${xl?.span ? `col-xl-${xl.span}` : ''}`}`
  let nxxl = `${xxl!=="object" && xxl && xxl.constructor !== Object ? `col-xxl-${xxl}`: `${xxl?.span ? `col-xxl-${xxl.span}` : ''}`}`
  nxs += `${xs?.order ? ` order-${xs.order}`: ''}`
  nsm += `${sm?.order ? ` order-sm-${sm.order}`: ''}`
  nmd += `${md?.order ? ` order-md-${md.order}`: ''}`
  nlg += `${lg?.order ? ` order-lg-${lg.order}`: ''}`
  nxl += `${xl?.order ? ` order-xl-${xl.order}`: ''}`
  nxxl += `${xxl?.order ? ` order-xxl-${xxl.order}`: ''}`
  nxs += `${xs?.offset ? ` offset-${xs.offset}`: ''}`
  nsm += `${sm?.offset ? ` offset-sm-${sm.offset}`: ''}`
  nmd += `${md?.offset ? ` offset-md-${md.offset}`: ''}`
  nlg += `${lg?.offset ? ` offset-lg-${lg.offset}`: ''}`
  nxl += `${xl?.offset ? ` offset-xl-${xl.offset}`: ''}`
  nxxl += `${xxl?.offset ? ` offset-xxl-${xxl.offset}`: ''}`

  let colName = ""
  if (!nxs && !nsm && !nmd && !nlg && !nxl && !nxxl) 
  {
    colName = "col "
  }
  else
  {
    colName = `${nxs ? `${nxs} ` : ''}${nsm ? `${nsm} ` : ''}${nmd ? `${nmd} ` : ''}${nlg ? `${nlg} ` : ''}${nxl ? `${nxl} ` : ''}${nxxl ? `${nxxl} ` : ''}`
  }
  colName +=`${className ? ` ${className}` : ''}`
  
  return <div className={`${colName}`}>{children}</div>
}
export default Col
